export default {
  notifications(state) {
    return state.notifications;
  },
};
